import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on, Action } from '@ngrx/store';
import {
  DataModuleEntityId,
  DataModuleEntityRaw,
} from '@edgvr-front/data/domain';
import {
  DataModuleModulesListPageActions,
  DataModuleModulePageActions,
} from '../actions';

export const DATA_MODULES_FEATURE_KEY = 'data-modules';

export interface DataModulesState extends EntityState<DataModuleEntityRaw> {
  count: number;
  page: number;
  loading: boolean;
  loaded: boolean;
  selectedDataModuleId: null | DataModuleEntityId;
}

export const dataModulesAdapter: EntityAdapter<DataModuleEntityRaw> =
  createEntityAdapter<DataModuleEntityRaw>({
    sortComparer: (lhs: DataModuleEntityRaw, rhs: DataModuleEntityRaw) =>
      lhs.id - rhs.id,
    selectId: (_) => _.id,
  });

const initialState: DataModulesState = dataModulesAdapter.getInitialState({
  count: 0,
  page: 0,
  loading: false,
  loaded: false,
  selectedDataModuleId: null,
});

const reducer = createReducer(
  initialState,
  on(DataModuleModulesListPageActions.dataModulesList, (state, { page }) => ({
    ...state,
    loading: true,
  })),
  on(
    DataModuleModulesListPageActions.dataModulesListSuccess,
    (state, { dataModules, count, page }) =>
      dataModulesAdapter.setMany(
        dataModules.map((_) => _.toJSON()),
        {
          ...dataModulesAdapter.removeAll(state),
          count,
          page,
          loading: false,
          loaded: true,
        }
      )
  ),
  on(DataModuleModulesListPageActions.dataModulesListFailure, (state) => ({
    ...state,
    loading: false,
  })),
  on(DataModuleModulePageActions.selectedDataModuleSet, (state, { id }) => ({
    ...state,
    selectedDataModuleId: id,
  })),
  on(
    DataModuleModulePageActions.dataModuleGetSuccess,
    (state, { dataModule }) =>
      dataModulesAdapter.setOne(dataModule.toJSON(), state)
  )
);

export function dataModulesReducer(
  state: DataModulesState | undefined,
  action: Action
) {
  return reducer(state, action);
}
